package com.downdogapp.client

import com.downdogapp.*

interface MediaPlayer {

  val isPlaying: Boolean
  val canPlay: Boolean
  val currentTime: Duration
  val duration: Duration
  var volume: Double
  val isAirplayVideoActive: Boolean get() = false // iOS only
  val unexpectedIdleState: Boolean get() = false // Android only

  fun setFile(file: CommonUri?, seekTime: Duration? = null)
  fun seekToTime(time: Duration)
  fun play()
  fun pause()
  fun releasePlayer()
  fun onFinishedPlaying(callback: () -> Unit)

  fun togglePlaying() {
    if (isPlaying)
      pause()
    else
      play()
  }
}
